// extracted by mini-css-extract-plugin
export var annonce_header = "RhCtxJobAdHeaderSection-module--annonce_header--40dc8";
export var annonce_meta = "RhCtxJobAdHeaderSection-module--annonce_meta--9c6dd";
export var annonce_metas = "RhCtxJobAdHeaderSection-module--annonce_metas--794ef";